var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',_vm._g({staticClass:"kd-icon",attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":`#kd-icon-${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }